import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { SubscribedUserService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import { of } from 'rxjs';

export function saveSubscribedUser(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_SUBSCRIBED_USER),
    mergeMap(({ payload }) => {
      return SubscribedUserService.saveSubscribedUser(payload).pipe(
        map((res) =>
          actions.saveSubscribedUserSuccess(res.responceObject.records)
        ),
        catchError(error => of({
          type: actionTypes.SAVE_SUBSCRIBED_USER_FAILED,
          payload: error,
          error: true
        }))
      );
    })
  );
}

export function updateSubscribedUser(action$) {
  return action$.pipe(
    ofType(actionTypes.UPDATE_SUBSCRIBED_USER),
    mergeMap(({ payload }) => {
      return SubscribedUserService.updateSubscribedUser(payload).pipe(
        map((res) =>
          actions.updateSubscribedUserSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}


export function getSubscribedUser(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_SUBSCRIBED_USER),
    mergeMap(({ payload }) => {
      return SubscribedUserService.getSubscribedUser(payload).pipe(
        map((res) =>
          actions.getSubscribedUserSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function getSubscribedUsers(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_SUBSCRIBED_USERS),
    mergeMap(({ payload }) => {
      return SubscribedUserService.getSubscribedUsers(payload).pipe(
        map((res) =>
          actions.getSubscribedUsersSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function deleteSubscribedUser(action$) {
  return action$.pipe(
    ofType(actionTypes.DELETE_SUBSCRIBED_USER),
    mergeMap(({ payload }) => {
      return SubscribedUserService.deleteSubscribedUser(payload).pipe(
        map((res) => actions.deleteSubscribedUserSuccess(payload)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function generatePDF(action$) {
  return action$.pipe(
    ofType(actionTypes.GENERATE_PDF),
    mergeMap(({ payload }) => {
      return SubscribedUserService.generatePDF(payload).pipe(
        map((res) =>
        actions.generatePDFSuccess(res.responceObject.records)
        ),
        catchError(error => of({
          type: actionTypes.GENERATE_PDF_FAILED,
          payload: error,
          error: true
        }))
      );
    })
  );
}

export function getPdfStatus(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_PDF_STATUS),
    mergeMap(({ payload }) => {
      return SubscribedUserService.getPdfStatus(payload).pipe(
        map((res) =>
        actions.getPdfStatusSuccess(res.responceObject.records)
        ),
        catchError(error => of({
          type: actionTypes.GET_PDF_STATUS_FAILED,
          payload: error,
          error: true
        }))
      );
    })
  );
}

export function getPdfs(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_PDFS),
    mergeMap(({ payload }) => {
      return SubscribedUserService.getPdfs(payload).pipe(
        map((res) =>
        actions.getPdfsSuccess(res.responceObject.records)
        ),
        catchError(error => of({
          type: actionTypes.GET_PDFS_SUCCESS_FAILED,
          payload: error,
          error: true
        }))
      );
    })
  );
}

export function deletePdf(action$) {
  return action$.pipe(
    ofType(actionTypes.DELETE_PDF),
    mergeMap(({ payload }) => {
      return SubscribedUserService.deletePdf(payload).pipe(
        map((res) => actions.deletePdfSuccess(payload)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}




